
export const getPersisted = (key, defaultValue) => {
  const json = window.localStorage.getItem(key)
  if (json) { return JSON.parse(json) }

  if (defaultValue !== null && defaultValue !== undefined) {
    persist(key, defaultValue)
    return defaultValue
  }
  return json
}

export const persist = (key, value) => {
  window.localStorage.setItem(key, JSON.stringify(value))
}

export const clear = key => {
  window.localStorage.removeItem(key)
}
